import { mapActionsFromConfigurations } from '../../helpers/action';
import { configurations } from './configurations';
import { apiAction as getCardDetails } from './configurations/getCardDetails';
import { apiAction as getPlans } from './configurations/getPlans';
import { apiAction as getCoupon } from './configurations/getCoupon';

export const apiActions = {
  payment: {
    getPlans,
    getCardDetails,
    getCoupon,
  }
}

const actions = mapActionsFromConfigurations('payment')(configurations);

export * from './configurations/endpoints';

export default actions;


// WEBPACK FOOTER //
// ./src/state/modules/payment/actions.js